import {
  CircularProgress,
  FormControlLabel,
  Paper,
  Switch,
} from '@mui/material';
import { FormStateDataType } from 'containers/dashboard/Forms/FormListingType';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import axiosInstance from 'utils/axios';

function EnableDeals({
  InitalenableDeal,
  publishFormData,
  setPublishFormData,
  state,
  formUpdated,
  formData,
  setFormUpdated,
}: {
  InitalenableDeal: boolean;
  publishFormData: any;
  setPublishFormData: React.Dispatch<React.SetStateAction<any>>;
  state: FormStateDataType;
  formUpdated: number;
  formData: any;
  setFormUpdated: React.Dispatch<React.SetStateAction<number>>;
}) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [enableDeal, setEnableDeal] = useState<boolean>(InitalenableDeal);
  const [loading, setLoading] = useState<boolean>(false);
  const { formDetails } = useSelector((state: any) => state.formEditor);

  const showPreview =
    (publishFormData && formUpdated !== 0) ||
    (state.selectedHubspotFormId && formData.hubspot_form_id !== '',
    formData.hubspot_form_id !== '');

  useEffect(() => {
    setLoading(true);
    try {
      axiosInstance
        .post(
          '/formpayhome/portal/updatePortalFormSettings/' + formDetails.formId,
          {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            form_id: formDetails.formId,
            enable_deal: enableDeal,
          }
        )
        .then(resp => {
          if (resp.data.success === true) {
            setLoading(false);
            if (showPreview) {
              setPublishFormData(resp.data.data);
            }
          }
        });
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [enableDeal, enqueueSnackbar, formDetails.formId, setPublishFormData]);

  const makedealsEnabled = () => {
    if (enableDeal === false) {
      setEnableDeal(true);
    } else {
      setEnableDeal(false);
    }
  };

  useEffect(() => {
    // @ts-ignore
    if (publishFormData && window.showPreviewForForm) {
      setFormUpdated(value => value + 1);
    }
  }, [publishFormData]);

  return (
    <>
      <Paper
        className='p-2 rounded-lg mr-5 flex gap-2 items-center  mt-2'
        variant='outlined'
      >
        {loading ? <CircularProgress size={20} /> : <></>}
        <FormControlLabel
          className='ml-0'
          control={
            <Switch
              name='showDropdown'
              onChange={makedealsEnabled}
              checked={enableDeal}
            />
          }
          label={t('enable_deal')}
        />
      </Paper>
    </>
  );
}

export default EnableDeals;
